import { IconButton, TableCell, Tooltip } from "@mui/material";
import * as React from "react";
import { ACTIONS, options } from "./driveRowConst";
import useDrive from "../../hooks/useDrive";
import FileService from "../../services/FileService";
import { Buffer } from "buffer";

export default function DownloadActionCell({ show, row, cell, grid }) {
  const { CurrentDrive } = useDrive();

  const handleMenuItemClick = (action) => {
    switch (action) {
      case ACTIONS.FILE_DOWNLOAD:
        downloadFile(row);
        break;
      default:
        break;
    }
  };

  const downloadFile = async (row) => {
    const { parent, driveType } = CurrentDrive;
    const url = await FileService.getDownLoadLink(parent, row.Key, driveType);
    download(url.url || url);
  };

  function download(source) {
    // localStorage.setItem('callback', 'smilefyappconnections://')

    if (localStorage.getItem("callback")) {
      let params = [
        {
          url: source,
        },
      ];

      let result = `${localStorage.getItem("callback")}data=${Buffer.from(
        JSON.stringify(params)
      ).toString("base64")}`;
      // console.log(result);
      window.location.replace(result);
    } else {
      const fileName = source.split("/").pop();
      let el = document.createElement("a");
      el.setAttribute("href", source);
      el.setAttribute("download", fileName);
      el.setAttribute("target", "_blank");
      document.body.append(el);
      el.click();
      el.remove();
    }
  }

  const loadActions = (menu = false) => {
    if (!row) {
      return "";
    }
    const optionsArr = options[row.type];
    let actions = [];
    if(optionsArr) {
      for (let i = 0; i < optionsArr.length; i++) {
        const { action, text, icon, permissions } = optionsArr[i];
        const { drivePermission } = CurrentDrive;
        const findPermission = permissions.find((p) => drivePermission === p);
        if (!findPermission) {
          continue;
        }

        if (row.type === "file" && action === ACTIONS.FILE_DOWNLOAD) {
          actions.push(
              <Tooltip title={text}>
                <IconButton
                    size={"small"}
                    key={i + action}
                    onClick={() => handleMenuItemClick(action)}
                    variant={"contained"}
                    // color={"info"}
                    style={{ color: "#8c3b61" }}
                >
                  {icon}
                </IconButton>
              </Tooltip>
          );
        }
      }

    }
    return actions;
  };
  return (
    <>
      <TableCell align="right">{loadActions(true)} </TableCell>
    </>
  );
}
